import { PCTypes } from "@/types/db/product-category";

/**
 * Ticket types that give access to a venue. Gift cards, merchandising,
 * donations and retail lines never give access, so check-in ignores them.
 * The check-in page and the Orders count read the same list, so the two
 * never disagree on what an order holds.
 */
export const ACCESS_TICKET_TYPES: number[] = [
  PCTypes.Normal,
  PCTypes.Seated,
  PCTypes.SeatedSub,
  PCTypes.SeatedPass,
  PCTypes.EventPass,
  PCTypes.Event,
  PCTypes.AddOn,
  PCTypes.Membership,
  PCTypes.OVV,
  PCTypes.MembershipSeated,
  PCTypes.Recurring,
];
